import React, { FC } from 'react'
import styled from 'styled-components'
import { Button, Modal } from 'components/base-ui'
import { weight } from 'components/base-ui/Fonts'
import { useTranslation } from 'react-i18next'

interface ModalWarningTotalZeroDueProps {
  isOpen: boolean
  onClose: () => void
  onClickButton: () => void
}

const ModalWarningTotalZeroDue: FC<ModalWarningTotalZeroDueProps> = ({ isOpen, onClose, onClickButton }) => {
  const { t } = useTranslation()
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} shouldCloseOnOverlayClick={false} hideCloseButton={false}>
      <ModalContainer>
        <ModalTitle>{t('promotion.modal.cashVeoucherWithTotalZeroDue.title')}</ModalTitle>
        <ModalText style={{ marginBottom: '20px' }}>
          {t('promotion.modal.cashVeoucherWithTotalZeroDue.description')}
        </ModalText>
        <Button onClick={onClickButton} md minWidth="175px" enableFastClick={false}>
          {t('promotion.modal.cashVeoucherWithTotalZeroDue.button')}
        </Button>
      </ModalContainer>
    </Modal>
  )
}

export default ModalWarningTotalZeroDue

const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const ModalTitle = styled.div`
  font-weight: ${weight.medium};
  font-size: ${({ theme }) => theme.fontSize.xxl};
  color: ${({ theme }) => theme.colors.gray900};
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing['3XL']};
  white-space: pre-wrap;
  line-height: 1.4em;
`

const ModalText = styled.div`
  font-weight: ${weight.normal};
  font-size: ${({ theme }) => theme.fontSize.lg};
  color: ${({ theme }) => theme.colors.gray700};
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing.S};
  margin-bottom: ${({ theme }) => theme.spacing.S};
  white-space: pre-wrap;
`
